/* istanbul ignore file */
import produce from 'immer';

import * as overrides from './addEquipmentInputFormSchema.overrides';

export const schema = produce(
  {
    type: 'object',
    properties: {
      name: {
        type: 'string',
        title: 'Name',
      },
      assetId: {
        type: 'string',
        title: 'Asset Id',
      },
      calibrationDueDate: {
        type: 'string',
        title: 'Calibration Due Date',
      },
      usage: {
        title: 'Usage',
        type: 'string',
        enum: ['VisualInspection', 'PerformanceTest'],
        enumNames: ['Visual Inspection', 'Performance Test'],
      },
    },
  },
  overrides.schema
);

export const uiSchema = produce({}, overrides.uiSchema);

export const mapToEdit = overrides.mapToEdit();

export const fields = produce({}, overrides.fields);

export const widgets = produce({}, overrides.widgets);

export const validation = overrides.validation();

export const empty = overrides.empty({
  name: '',
  assetId: '',
  calibrationDueDate: '',
  usage: [],
});
